import { createSelector } from 'reselect';

import type { TState } from '~/src/store';
import type { IPromoStore } from '~/src/store/reducers/promo';

/**
 * Получить данные промо карточки по id
 *
 * @function
 * @name store.selectors.promo.selectPromoStatusAtId
 * @param {TState} state - Состояние
 * @param {number} id - id карточки
 * @returns {IPromoStore}
 */
export const selectPromoStatusAtId = (state: TState, id: number): IPromoStore => {
    return state.promo[id] || {};
};

/**
 * Получить статус промо карточки по id
 *
 * @function
 * @name store.selectors.promo.selectPromoStatus
 * @param {IPromoStore} card - данные карточки
 * @returns {IPromoStore['isActive']}
 */
export const selectPromoStatus = createSelector(
    selectPromoStatusAtId,
    (card: IPromoStore): IPromoStore['isActive'] => card.isActive,
);

/**
 * Получить категорию промо карточки по id
 *
 * @function
 * @name store.selectors.promo.selectPromoStatus
 * @param {IPromoStore} card - данные карточки
 * @returns {IPromoStore['category']}
 */
export const selectPromoCategory = createSelector(
    selectPromoStatusAtId,
    (card: IPromoStore): IPromoStore['category'] => card.category,
);

/**
 * Получить id возможного действия (подключение/отключение) промо карточки по id
 *
 * @function
 * @name store.selectors.promo.selectPromoStepId
 * @param {IPromoStore} card - данные карточки
 * @returns {IPromoStore['stepId']}
 */
export const selectPromoStepId = createSelector(
    selectPromoStatusAtId,
    (card: IPromoStore): IPromoStore['stepId'] => card.stepId,
);
